import { render, staticRenderFns } from "./Dongxin.vue?vue&type=template&id=483e4af0&"
import script from "./Dongxin.vue?vue&type=script&lang=js&"
export * from "./Dongxin.vue?vue&type=script&lang=js&"
import style0 from "./Dongxin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports